const title = process.env.STORE_TITLE;
const description = process.env.STORE_DESCRIPTION;
const siteName = process.env.NEXT_PUBLIC_STORE_NAME_SEO;
const url = process.env.NEXT_PUBLIC_STORE_URL;
export const SEO = {
  title,
  description,
  canonical: url,
  openGraph: {
    type: "website",
    locale: "pt_BR",
    url: url,
    site_name: siteName,
    title,
    description,
    images: [
      {
        url: "https://cdn.pneufree.com.br/LINGLONG/images/Site/img/CAPA-LINK-ECOMMERCE-LINGLONG.jpg",
        alt: title,
        type: "image/jpeg",
        width: 1200,
        height: 628
      }
    ]
  },
  twitter: {
    handle: "@pneufree",
    site: "@pneufree",
    cardType: "summary_large_image"
  },
  facebook: {
    handle: "@pneufree",
    site: "@pneufree",
    appId: "320832306475546"
  }
};
